import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-arrow-down-filled",
  "use": "ico-arrow-down-filled-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 10\" id=\"ico-arrow-down-filled\">\n  <path id=\"ico-arrow-down-filled_Polygon_47\" data-name=\"Polygon 47\" d=\"M8.628.413a.5.5,0,0,1,.743,0l7.877,8.753a.5.5,0,0,1-.372.834H1.123a.5.5,0,0,1-.372-.834Z\" fill=\"#737878\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol